module.exports = __webpack_public_path__ + "static/img/building.93e8f1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/building.jpg
// module id = OgqV
// module chunks = 1